import { useEffect, useState } from 'react';

export default function useMediaQuery(query) {
  const getMatches = (query) => {
    // Prevents SSR issues
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState(getMatches(query));

  function handleChange() {
    setMatches(getMatches(query));
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    let listener = null;
    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    if (!listener) {
      listener = matchMedia.addEventListener('change', handleChange);
    }

    return () => {
      if (listener) {
        matchMedia.removeEventListener('change', handleChange);
      }
    };
  }, [query]);

  return matches;
}
